module.exports = __webpack_public_path__ + "static/media/maram-kh.e30612ae.jpg";